import { render, staticRenderFns } from "./ReportMonitoreoUci.vue?vue&type=template&id=e0d8b5b2"
import script from "./ReportMonitoreoUci.vue?vue&type=script&lang=js"
export * from "./ReportMonitoreoUci.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports